import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
import store from '../store'

const pageRoutes = [
  ['home', 'Главная'],
  ['about', 'О клинике'],
  ['services', 'Услуги', 'Услуга'],
  ['serviceDetail', 'Детальная услуга'],
  ['prices', 'Прайс'],
  ['shop', 'Магазин'],
  ['blog', 'Блог'],
  ['contacts', 'Контакты']
].map(([key, title]) => ({
  path: `/pages/${key}`,
  name: `page-${key}`,
  meta: { title },
  component: () => import('../views/pages/PageEditor.vue'),
  props: { pageKey: key }
}))

const collectionRoutes = [
  ['clinics', 'Клиники', 'Клиника'],
  ['services', 'Услуги', 'Услуга'],
  ['products', 'Товары', 'Товар'],
  ['articles', 'Статьи', 'Статья']
].flatMap(([key, title, singleTitle]) => ([
  {
    path: `/collections/${key}`,
    name: `collection-${key}`,
    meta: { title },
    component: () => import('../views/collections/CollectionListView.vue'),
    props: { collectionKey: key }
  },
  {
    path: `/collections/${key}/:id`,
    name: `collection-${key}-item`,
    meta: { title: singleTitle },
    component: () => import('../views/collections/CollectionEditor.vue'),
    props: route => ({ collectionKey: key, itemId: route.params.id, draftId: route.query.id })
  }
]))

const seoRoutes = [
  ['global', 'SEO: общие настройки'],
  ['pages', 'SEO: страницы'],
  ['entities', 'SEO: сущности'],
  ['scripts', 'SEO: скрипты и метрики', 'Admin']
].map(([tab, title, requiredRole]) => ({
  path: `/seo/${tab}`,
  name: `seo-${tab}`,
  meta: requiredRole ? { title, requiredRole } : { title },
  component: () => import('../views/seo/SeoView.vue'),
  props: { tab }
}))

const routes = [
  { path: '/login', name: 'login', meta: { title: 'Вход', public: true }, component: () => import('../views/LoginView.vue'), props: { mode: 'login' } },
  { path: '/register', name: 'register', meta: { title: 'Регистрация', public: true }, component: () => import('../views/LoginView.vue'), props: { mode: 'register' } },
  { path: '/reset-password', name: 'reset-password', meta: { title: 'Восстановление пароля', public: true }, component: () => import('../views/LoginView.vue'), props: { mode: 'reset' } },
  { path: '/', name: 'dashboard', meta: { title: 'Обзор', ownPageHead: true }, component: () => import('../views/DashboardView.vue') },
  { path: '/logs', name: 'logs', meta: { title: 'Журнал действий' }, component: () => import('../views/LogsDashboard.vue') },
  { path: '/settings', name: 'settings', meta: { title: 'Настройки' }, component: () => import('../views/SettingsView.vue') },
  { path: '/users', name: 'users', meta: { title: 'Пользователи', requiredRole: 'Admin' }, component: () => import('../views/UsersView.vue') },
  { path: '/users/:uid', name: 'userDetail', meta: { title: 'Пользователь', requiredRole: 'Admin' }, component: () => import('../views/UserDetailView.vue'), props: true },
  { path: '/service-orders', name: 'service-orders', meta: { title: 'Заявки на услуги' }, component: () => import('../views/FeedbackView.vue'), props: { requestType: 'service' } },
  { path: '/shop-orders', name: 'shop-orders', meta: { title: 'Заявки магазина' }, component: () => import('../views/FeedbackView.vue'), props: { requestType: 'shop' } },
  { path: '/feedback', redirect: '/feedback/messages' },
  {
    path: '/feedback/:feedbackTab(messages|callback)',
    name: 'feedback',
    meta: { title: 'Обратная связь' },
    component: () => import('../views/FeedbackView.vue'),
    props: route => ({
      requestType: 'feedback',
      initialTab: route.params.feedbackTab === 'callback' ? 'CallBack' : 'ContactMessages'
    })
  },
  { path: '/callback', redirect: '/feedback/callback' },
  { path: '/pages/general', name: 'general', meta: { title: 'Общее' }, component: () => import('../views/pages/GeneralPageEditor.vue') },
  ...pageRoutes,
  { path: '/categories', name: 'categories', meta: { title: 'Категории' }, component: () => import('../views/CategoriesView.vue') },
  { path: '/seo', redirect: '/seo/global' },
  ...seoRoutes,
  ...collectionRoutes,
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  }
})

router.beforeEach(async to => {
  await store.dispatch('initAuth')

  if (to.meta.public) {
    if (store.getters.isAuthenticated) return '/'
    return true
  }

  if (!store.getters.isAuthenticated) {
    return {
      path: '/login',
      query: to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : {}
    }
  }

  if (to.meta.requiredRole === 'Admin' && !store.getters.isAdmin) {
    store.dispatch('notify', {
      type: 'warning',
      title: 'Недостаточно прав',
      message: 'Раздел доступен только администратору.'
    })
    return '/'
  }

  return true
})

export default router
